import * as $ from 'jquery';

class RuntimeFrame {
    static staticName = "runtimeFrame";
    eventBroker;
    topFrameId;
    nodes;
    frameId;
    nextNode;
    styles;
    displayType;
    endOfFrame = false;

    constructor(eventBroker, data, rtFactory) {
        this.eventBroker = eventBroker;
        this.topFrameId = "frame_0";
        this.nodes = {};
        this.frameId = data.frameId;
        this.styles = data.styles;
        this.displayType = data.displayType ?? "one-by-one";
        this.hookup();

        for (var nodeIndex in data.nodes) {
            var newNode = rtFactory.getNode(data.nodes[nodeIndex], rtFactory);
            this.nodes[newNode.nodeId] = newNode;
        }
    }

    getRuntimeView() {
        var $frame = $(`<div id="frame_id_${this.frameId}" class='sid-sub-frame'></div>`);

        if (this.styles)
            $frame.addClass(this.styles);

        if (this.frameId == this.topFrameId)
            $frame.removeClass("sid-sub-frame")

        for (var nodeIndex in this.nodes) {
            $frame.append(this.nodes[nodeIndex].getRuntimeView());
        }

        return $frame;
    }

    presentFrame() {
        if (this.displayType == "all-at-once")
            this.presentAllNodes();
        else if (this.displayType == "one-by-one")
            this.findFirstNode().presentNode();
        else if (this.displayType == "sequential")
            this.findFirstNode().presentNode();
        else
            console.error("Unknown displayType: " + this.displayType);
    }

    findFirstNode() {
        for (var nodeIndex in this.nodes) {
            if (this.nodes[nodeIndex].openConditionIsMet())
                return this.nodes[nodeIndex];
        }
    }

    hookup() {
        this.eventBroker.subscribe("nexButtonClickedEvent", function (nodeId) {
            if (this.endOfFrame)
                return;

            if (this.nodes[nodeId]) {
                this.fireValueChanged(nodeId);
                this.unPresentNode(nodeId);
                this.findNextNode(nodeId);
            }
        }.bind(this));

        if (this.displayType == "sequential") {
            this.eventBroker.subscribe("nodeShownEvent", function (nodeId) {
                let found = false;
                for (var node in this.nodes) {
                    if (found) {
                        this.nodes[node].presentNode();
                        found = false;
                    }
                    if (node == nodeId)
                        found = true;
                }
            }.bind(this));
        }
    }

    findNextNode(nodeId) {
        var found = false;
        for (var nodeIndex in this.nodes) {
            if (found && this.nodes[nodeIndex].openConditionIsMet()) {
                this.nextNode = this.nodes[nodeIndex];
                return;
            }

            if (nodeIndex == nodeId)
                found = true;
        }
        if (found) { //last node in frame opend.
            this.endOfFrame = true;
            this.eventBroker.fire("endOfFrameEvent", this.frameId);
        }
    }

    presentAllNodes() {
        for (var node in this.nodes) {
            this.nodes[node].presentNode();
        }
    }

    unPresentNode(nodeId) {
        this.nodes[nodeId].unPresentNode(this.showNext.bind(this));
    }

    showNext() {
        if (this.nextNode && this.nextNode.presentNode)
            this.nextNode.presentNode();
    }

    setLanguage(texts) {
        for (var node in this.nodes) {
            this.nodes[node].setLanguage(texts);
        }
    }

    fireValueChanged(nodeId) {
        if (this.displayType == "all-at-once" || this.displayType == "sequential")
            this.fireAllOutputEvents();
        else if (this.nodes[nodeId])
            this.nodes[nodeId].fireValueChanged(nodeId);
    }

    fireAllOutputEvents() {
        for (var node in this.nodes) {
            this.nodes[node].fireValueChanged();
        }
    }

    allNextButtonsEnabled() {
        for (var node in this.nodes) {
            if (this.nodes[node].component.nextButtonEnabled == false)
                return false;
        }
        return true;
    }

    containsComponentId(componentId) {
        for (var node in this.nodes) {
            if (this.nodes[node].component.id == componentId)
                return true;
        }
        return false;
    }
}

export { RuntimeFrame }